// react
import React, { useState, useEffect, useContext} from 'react';
import useForm from 'react-hook-form';
import ReactTable from "react-table";
import moment from "moment";
import { useTranslation } from 'react-i18next';
import Datetime from "react-datetime";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Edit from "@material-ui/icons/Edit";

// @material-ui components
import Tooltip from "@material-ui/core/Tooltip";

// core components
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from '@material-ui/core/TextField';
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import Badge from "beaktShared/components/Badge/Badge.js";
import RoyaltieForm from "./RoyaltieForm";

// services
import { MaskDate, formateDate, formateMesAno, validateDateMesAno, convertDate, transformValueFloattoFormated, transformValueFormatedtoFloat, getLocale, getStringMesAno } from "beaktShared/helpers/masks";
import { UsePostApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";
import { isRegraV2, resultadoFechamentoV2 } from "beaktShared/helpers/royaltyDisplay";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';
const useStyles = makeStyles(styles);

export default function RoyaltiesList({history}) {
    const { t } = useTranslation(); 
    const session = useContext(SessionContext);
    const { register, setValue, errors, setError, clearError, getValues } = useForm({mode: "onChange"});


    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };
    
    const endPoint = 'royalties/';  
    const [item, setItem] = useState({});
    
    const [dtini, setdtini] = React.useState(formateMesAno(moment(new Date()).add(-6, 'months')));
    const [dtfim, setdtfim] = React.useState(formateMesAno(moment(new Date())));

    useEffect(() => {
        loadList();
    }, []);    

    const getEndPoint = () => {
        let endPointGet = "";
        endPointGet =  endPoint +"byestabelecimento/"+ session.estabelecimentoId;
        return  endPointGet;
    }
    
    const [isLoadingList, setisLoadingList] = React.useState(false);
    const [list, setlist] = React.useState([]);
    const loadList = () =>{
        
        let obj = {
            dataIni:dtini,
            dataFim:dtfim
        }

        setisLoadingList(true);       
        const endPoint = getEndPoint();
        UsePostApi(endPoint,obj).then(result=>{    
            if(result.status !== 200)
            {   
                showNotification(result.message, 'danger')
                setisLoadingList(false);
                return false; 
            }    
            setlist(result.data);
            setisLoadingList(false); 
                        
            return true;                
        });  
    }

    const monthDiff = (dateFrom, dateTo) => {
        return dateTo.getMonth() - dateFrom.getMonth() + 
        (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
    }
    const handleClickPesquisa = () =>{
        let data = getValues();
        
        if(data.dtini === "")
        {
            setError("dtini","required", t('label.required'))
            return false;
        }
        else
            clearError("dtini")
        
        if(data.dtfim === "")
        {
            setError("dtfim","required", t('label.required'))
            return false;
        }
        else
            clearError("dtfim")
        
        if (!validateDateMesAno(data.dtini)) {
            setError("dtini", "invaliddate", t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("dtini")
        
        if (!validateDateMesAno(data.dtfim)) {
            setError("dtfim", "invaliddate", t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("dtfim")
        
        var dataIniConvertida = convertDate("01/"+data.dtini);
        var dataFimConvertida = convertDate("01/"+data.dtfim);
        
        if(monthDiff(dataIniConvertida,dataFimConvertida) > 6){            
            showNotification(t('error_message.select_a_period_of_maximum_6_months'), 'danger')
            return false; 
        }        

        setdtini(data.dtini);
        setdtfim(data.dtfim);

        loadList();
    };

    const [showFormView, setshowFormView] = React.useState(false);
    const handleView = (resetItem) => {    
        if(resetItem)
            setItem({});
        let show = showFormView === true ? false : true;
        setshowFormView(show);        
        
        if(dtini)
            setValue('dtini', formateMesAno(dtini));             
        if(dtfim)
            setValue('dtfim', formateMesAno(dtfim));

    };

    const handleEdit = row => {       
        setItem(row);
        handleView(false);
    };

    const handleAdd = (message) =>{
        showNotification(message,'success');
        handleView(true);
        loadList();
    }

    // Coluna Regra (nova/anterior) só para admin (0) e matriz (4)
    const isMaster = session.tipoPerfil == 0 || session.tipoPerfil == 4;

    const columnsProp = [{
        Header: "Status",
        accessor: "status",
        Cell: (row) => { 
            if (row.original.status == "0-Aguardando OK para pagamento")
                return <span><Badge color="info"> Aguardando Aceite </Badge></span>
            else if (row.original.status == "1-Aguardando execução do pagamento")
                return <span><Badge color="warning"> Aguardando Pagamento </Badge></span>
            else if (row.original.status == "2-Pagamento efetuado")
                return <span><Badge color="success"> Pagamento Efetuado </Badge></span>
            else if (row.original.status == "3-Fechamento Estornado")
                return <span><Badge color="danger"> Fechamento Estornado </Badge></span>
            else
                return <span><Badge>{row.original.status} </Badge></span>                
        }, 
    },
    {
        Header: t('label.month_year'),
        accessor: "mesAno",
        Cell: (row) => <strong>{row.value}</strong>
    },
    {
        Header: t('royaltie.rule'),
        id: "regraVersao",
        show: isMaster,
        accessor: (row) => isRegraV2(row) ? t('royaltie.rule_v2') : t('royaltie.rule_legacy'),
        Cell: (row) => <span><Badge color={isRegraV2(row.original) ? "info" : "gray"}>{row.value}</Badge></span>
    },
    {
        Header: t('label.dt_accept'),
        accessor: "dataAceite",
        Cell : (row)=> {
            if (row.original.status === "3-Fechamento Estornado") return "";
            let custom_date = row.value ? formateDate(row.value) : "";
            return <span>{custom_date}</span>
        }
    },
    {
        Header: t('label.dt_payment'),
        accessor: "dataPagamento",
        Cell : (row)=>{
            if (row.original.status === "3-Fechamento Estornado") return "";
            let custom_date = row.value ? formateDate(row.value) : "";
            return <span>{custom_date}</span>
        }
    },
    {
        Header: t('label.parcels'),
        accessor: "mediaParcelas",
        Cell: (row) => {
            if (row.original.status === "3-Fechamento Estornado") return "";
            return <div> {Math.round(row.value)} </div>
        }
    },
    {
        Header: t('label.revenues'),
        accessor: "valorFaturamento",
        Cell: (row) => {
            if (row.original.status === "3-Fechamento Estornado") return "";
            return <div> {transformValueFloattoFormated(row.value ? row.value : 0)} </div>
        }
    },
    {
        Header: t('label.receive_pay'),  
        id: "valorReceberPagar",
        accessor: (row) => isRegraV2(row) ? resultadoFechamentoV2(row) : row.valorReceberPagar,
        Cell: (row) => {
            if (row.original.status === "3-Fechamento Estornado") return "";
            return <div> {transformValueFloattoFormated(row.value ? row.value : 0)} </div>
        }
    }]
    const columnsAcao = [
        {
            Header: t('label.actions'),
            Cell: row => (
                <div className="actions-right">
                    {
                        row.original.status !== "3-Fechamento Estornado" && (
                        <>
                            <Button
                                justIcon
                                round
                                simple
                                color="success"
                                className="edit"
                                onClick={() => handleEdit(row.original)}
                            >
                                <Tooltip title={t('label.to_edit')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                                <Edit />
                                </Tooltip>
                            </Button>
                            {" "}
                        </>
                    )}
                </div>
            ),
            sortable: false,
            filterable: false
        }
    ];
    const columns = [...columnsProp,...columnsAcao]

    const classes = useStyles();
    return (
        <div>
            {showFormView && 
                <RoyaltieForm addItem={handleAdd} item={item} handleView={handleView} history={history} />} 
            
            {!showFormView &&
                <GridContainer>            
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Assignment />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>{t('register.list_of_royalties')}</h4>
                        </CardHeader>
                        <CardBody>

                            <GridContainer>
                            <GridItem xs={12} sm={6} md={3}>
                                <FormControl fullWidth className={classes.formControl}>                                                               
                                    <label className={errors.dtini?"select__label select__label_error":"select__label"}>
                                        {t('label.start_month_year')+" *"}  </label>
                                    <Datetime                                    
                                        locale={getLocale()}
                                        dateFormat={getStringMesAno()}
                                        timeFormat={false}                                    
                                        name="dtini"                                      
                                        defaultValue={dtini}
                                        value={dtini}
                                        onChange={date => { setdtini(date) }}
                                        inputProps={{name:"dtini", ref:register({required: true}) , readOnly:'readonly' }}                                    
                                        className={errors.dtini?"error":""}            
                                    />       
                                    {errors.dtini && <FormHelperText className={classes.labelRootError}>
                                        <span> {errors.dtini.message} </span>                                                                          
                                    </FormHelperText>} 
                                </FormControl>                                     
                            </GridItem>
                            <GridItem xs={12} sm={6} md={3}>
                                <FormControl fullWidth className={classes.formControl}>                                                               
                                    <label className={errors.dtfim?"select__label select__label_error":"select__label"}>
                                        {t('label.end_month_year')+" *"}  </label>
                                    <Datetime                                    
                                        locale={getLocale()}
                                        dateFormat={getStringMesAno()}
                                        timeFormat={false}                                    
                                        name="dtfim"                                      
                                        defaultValue={dtfim}
                                        value={dtfim}
                                        onChange={date => { setdtfim(date) }}
                                        inputProps={{name:"dtfim", ref:register({required: true}) , readOnly:'readonly' }}                                    
                                        className={errors.dtfim?"error":""}            
                                    />       
                                    {errors.dtfim && <FormHelperText className={classes.labelRootError}>
                                        <span> {errors.dtfim.message} </span>                                                                          
                                    </FormHelperText>} 
                                </FormControl>    
                            </GridItem>
                            <GridItem xs={12} sm={6} md={2}>
                                <Button  round color="primary" 
                                    onClick={e => { handleClickPesquisa()}}>
                                    {t('button.search')}
                                </Button>
                            </GridItem>
                            </GridContainer>
                            
                            <ReactTable
                                loading = {isLoadingList}
                                data={list}
                                filterable
                                defaultFilterMethod = {noCaseSensitive}
                                columns={columns}
                                defaultPageSize={10}
                                minRows={5}
                                showPaginationBottom={true}
                                className="-striped -highlight"
                                previousText={t('button.previous')}
                                nextText={t('button.next')}
                                loadingText={t('label.loading')+"..."}
                                noDataText={t('information_message.no_records_found')+"!"}
                                pageText={t('label.page')}
                                ofText={t('label.of')}
                                rowsText={t('label.rows')}
                            />
                        </CardBody>
                    </Card>
                </GridItem>            
            </GridContainer>
            }  

            <Snackbar
            place="tr"
            color={notification.color}
            message={notification.message}
            open={notification.show}
            closeNotification={() => setNotification(false)}
            close
            />
                     
        </div>
    );
}
